/**
 * Validation regex patterns for KYB Stakeholder forms
 *
 * @see https://backmarket.atlassian.net/wiki/spaces/MCC/pages/5102371391/tech+specs+KYB+form+validation+rules
 */
export const VALIDATION_REGEX = {
  /**
   * Name validation (First Name & Last Name)
   *
   * Allows letters including accented characters, spaces, hyphens, and periods.
   * No specific length validation - handled separately.
   */
  NAME: /^[a-zA-ZÀ-ÿ\s\-.]+$/,

  /**
   * Phone Number validation (E164 format)
   *
   * Must be in E164 format with max 17 characters.
   * Allows numbers and + only.
   *
   * Examples: "+13175551212", "+33123456789"
   */
  PHONE_NUMBER: /^\+[\d]{1,16}$/,

  /**
   * Address Line 1 validation
   *
   * Max 100 characters. Allows letters, numbers, space, and # ' ( ) , - . / : ; ° &
   * Min 2 characters.
   *
   * Unicode ranges:
   * - \u00C0-\u00FF: Latin-1 Supplement (À, Á, Â, etc.)
   * - \u0100-\u017F: Latin Extended-A (Ā, Ă, Ą, etc.)
   * - \u0180-\u024F: Latin Extended-B (ƀ, Ɓ, Ƃ, etc.)
   */
  ADDRESS_LINE:
    /^[\sa-zA-Z0-9/\-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/,

  /**
   * City validation
   *
   * Max 50 characters. Allows letters, space, and & ' ( ) - .
   * Min 2 characters.
   *
   * Unicode ranges for international characters:
   * - \u00C0-\u00FF: Latin-1 Supplement (À, Á, Â, etc.)
   * - \u0100-\u017F: Latin Extended-A (Ā, Ă, Ą, etc.)
   * - \u0180-\u024F: Latin Extended-B (ƀ, Ɓ, Ƃ, etc.)
   */
  CITY: /^[\sa-zA-Z0-9\-().,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,50}$/,

  /**
   * Postal Code validation
   *
   * Allows letters, numbers, spaces, and hyphens.
   * Min 2, max 16 characters.
   * Cannot be only hyphens.
   */
  POSTAL_CODE: /^(?![-]+$)[\sa-zA-Z0-9-]{2,16}$/,
} as const

/**
 * Age validation constants
 */
export const AGE_LIMITS = {
  MINIMUM_AGE: 18,
} as const

/**
 * Identification types for stakeholders
 * Based on product requirements: Only National Identity Card and Passport
 */
export const IDENTIFICATION_TYPES = {
  PASSPORT: 'PASSPORT',
  NATIONAL_ID: 'NATIONAL_ID',
} as const
